module.exports = __webpack_public_path__ + "img/HNYT087_20.ce4b5ed7.gif";